<template>
    <div class="row col-12">
        <!--Usage
        <date-time-range :startTime.sync="startTime"
                         :endTime.sync="endTime"
                         :useLocalTime="true">
        </date-time-range>-->

        <div class="form-group col-md-6 col-sm-12">
            <label class="font-weight-bold" :class="required ? 'required' : ''" :for="'startTime' + _uid">{{ $t(startTitle) }}</label>
            <div :id="'startTime' + _uid">
                <date-picker ref="startDatePicker"
                             :id="'startTime1'"
                             v-model="startTimeModel"
                             v-validate="required ? 'required' : ''"
                             :data-vv-as="$t(startTitle)"
                             :min="datePickerItem.startMinDate"
                             :max="datePickerItem.startMaxDate"
                             :name="'startTime' + _uid"
                             :useUtcTime="useUtcTime"
                             :convertToLocalTime="!useUtcTime"
                             :format="dateTimeCustomFormat"
                             :showTime="showTime"
                             :readonly="readonly"
                             :required="false"
                             :showOnlyYear="showOnlyYear"
                             aria-describedby="startHelp"
                             @input="startChange"></date-picker>
                <small id="startHelp" class="form-text text-muted">{{ $t(startDescription) }}</small>
                <span class="text-danger" v-if="errors.has('startTime' + _uid)">{{ errors.first('startTime' + _uid) }}</span>
            </div>
        </div>
        <div class="form-group col-md-6 col-sm-12">
            <label class="font-weight-bold" :class="required ? 'required' : ''" :for="'endTime' + _uid">{{ $t(endTitle) }}</label>
            <div :id="'endTime' + _uid">
                <date-picker ref="endDatePicker"
                             :id="'endDate1'"
                             v-model="endTimeModel"
                             v-validate="required ? 'required' : ''"
                             :data-vv-as="$t(endTitle)"
                             :min="datePickerItem.endMinDate"
                             :max="datePickerItem.endMaxDate"
                             :name="'endTime' + _uid"
                             :useUtcTime="useUtcTime"
                             :convertToLocalTime="!useUtcTime"
                             :format="dateTimeCustomFormat"
                             :showTime="showTime"
                             :readonly="readonly"
                             :required="false"
                             :showOnlyYear="showOnlyYear"
                             aria-describedby="endHelp"
                             @input="endChange"></date-picker>
                <small id="endHelp" class="form-text text-muted">{{ $t(endDescription) }}</small>
                <span class="text-danger" v-if="errors.has('endTime' + _uid)">{{ errors.first('endTime' + _uid) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from '../../components/datepicker/DatePicker';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            required: {
                type: Boolean,
                default: false
            },
            startTime: {
                type: [Date, String],
                required: false
            },
            endTime: {
                type: [Date, String],
                required: false
            },
            format: {
                type: String
            },
            showTime: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            min: {
                type: [Date, String],
                required: false
            },
            max: {
                type: [Date, String],
                required: false
            },
            showOnlyYear: {
                type: Boolean,
                default: false
            },
            useUtcTime: {
                type: Boolean,
                default: false
            },
            startTitle: {
                type: String,
                default: 'registers.forms.editor.validFrom'
            },
            endTitle: {
                type: String,
                default: 'registers.forms.editor.validTo'
            },
            startDescription: String,
            endDescription: String
        },
        components: {
            DatePicker
        },
        data() {
            return {
                datePickerItem: {},
                startTimeModel: this.startTime,
                endTimeModel: this.endTime
            };
        },
        methods: {
            startChange(e) {
                this.$emit('update:startTime', this.startTimeModel);

                let startDate = this.startTimeModel;
                let endDate = this.endTimeModel;

                if (startDate) {
                    startDate = new Date(startDate);
                    startDate.setDate(startDate.getDate());

                    this.datePickerItem.endMinDate = startDate;
                } else if (endDate) {
                    this.datePickerItem.startMaxDate = new Date(endDate);
                } else {
                    endDate = new Date();
                    this.datePickerItem.startMaxDate = endDate;
                    this.datePickerItem.endMinDate = endDate;
                }
            },
            endChange(e) {
                this.$emit('update:endTime', this.endTimeModel);

                let startDate = this.startTimeModel;
                let endDate = this.endTimeModel;

                if (endDate) {
                    endDate = new Date(endDate);
                    endDate.setDate(endDate.getDate());

                    this.datePickerItem.startMaxDate = endDate;
                } else if (startDate) {
                    this.datePickerItem.endMinDate = new Date(startDate);
                } else {
                    endDate = new Date();
                    this.datePickerItem.startMaxDate = endDate;
                    this.datePickerItem.endMinDate = new Date(startDate);
                }
            }
        },
        computed: {
            ...mapGetters(['dateTimeFormat']),
            dateTimeCustomFormat() {
                return this.format ? this.format : this.dateTimeFormat;
            }
        },
        watch: {
            startTime: function (val) {
                this.startTimeModel = val;
            },
            endTime: function (val) {
                this.endTimeModel = val;
            }
        },
        created() {
            if (this.min) {
                this.datePickerItem.startMinDate = this.min;
                this.datePickerItem.endMinDate = this.min;
            }

            if (this.max) {
                this.datePickerItem.startMaxDate = this.max;
                this.datePickerItem.endMaxDate = this.max;
            }
        },
        mounted() { }
    };
</script>
